export interface StorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

interface WithdrawalOfficialAppSnoozeKeyInput {
  userId?: string | number | null;
  countryCode?: string | null;
  installLink: string;
}

const STORAGE_PREFIX = "withdrawal_official_app_prompt:v1";
const FNV_OFFSET = 0x811c9dc5;
const FNV_PRIME = 0x01000193;

const getDefaultStorage = (): StorageLike | undefined => {
  try {
    return typeof window === "undefined" ? undefined : window.sessionStorage;
  } catch (_error) {
    return undefined;
  }
};

export const getWithdrawalOfficialAppReleaseFingerprint = (
  installLink: string,
): string => {
  let hash = FNV_OFFSET;
  const normalizedLink = installLink.trim();

  for (let index = 0; index < normalizedLink.length; index += 1) {
    hash ^= normalizedLink.charCodeAt(index);
    hash = Math.imul(hash, FNV_PRIME) >>> 0;
  }

  return hash.toString(16).padStart(8, "0");
};

export const buildWithdrawalOfficialAppSnoozeKey = ({
  userId,
  countryCode,
  installLink,
}: WithdrawalOfficialAppSnoozeKeyInput): string => {
  const userSegment =
    userId === undefined || userId === null || `${userId}`.trim() === ""
      ? "anonymous"
      : encodeURIComponent(`${userId}`);
  const countrySegment = (countryCode || "unknown").toUpperCase();
  const fingerprint = getWithdrawalOfficialAppReleaseFingerprint(installLink);

  return `${STORAGE_PREFIX}:${userSegment}:${countrySegment}:${fingerprint}`;
};

export const readWithdrawalOfficialAppSnooze = (
  key: string,
  storage: StorageLike | undefined = getDefaultStorage(),
): boolean => {
  try {
    return storage?.getItem(key) === "1";
  } catch (_error) {
    return false;
  }
};

export const writeWithdrawalOfficialAppSnooze = (
  key: string,
  storage: StorageLike | undefined = getDefaultStorage(),
): boolean => {
  try {
    if (!storage) return false;
    storage.setItem(key, "1");
    return true;
  } catch (_error) {
    return false;
  }
};

export const removeWithdrawalOfficialAppSnooze = (
  key: string,
  storage: StorageLike | undefined = getDefaultStorage(),
): boolean => {
  try {
    if (!storage) return false;
    storage.removeItem(key);
    return true;
  } catch (_error) {
    return false;
  }
};
